import type { DiffItem } from '@bits2schema/shared';
import type { MessageKey } from '../i18n/types';

/** Sdíleno mezi `HistoryPanel` (E3-US6) a `SyncPanel` (Epic 2) — obě zobrazují stejný `DiffItem` tvar. */
export const DIFF_OBJECT_TYPE_KEYS: Record<DiffItem['objectType'], MessageKey> = {
  table: 'history.diff.objectType.table',
  column: 'history.diff.objectType.column',
  primaryKey: 'history.diff.objectType.primaryKey',
  foreignKey: 'history.diff.objectType.foreignKey',
  uniqueConstraint: 'history.diff.objectType.uniqueConstraint',
  checkConstraint: 'history.diff.objectType.checkConstraint',
  index: 'history.diff.objectType.index',
};

export const DIFF_CHANGE_TYPE_KEYS: Record<DiffItem['changeType'], MessageKey> = {
  added: 'history.diff.changeType.added',
  changed: 'history.diff.changeType.changed',
  removed: 'history.diff.changeType.removed',
  renamed: 'history.diff.changeType.renamed',
};
